export const data = {
  name: window.localStorage.getItem('username'),
  initials: window.localStorage.getItem('image_url')
}